var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14762 0 0 5.14762 0 11.5C0 17.8524 5.14762 23 11.5 23C17.8524 23 23 17.8524 23 11.5C23 5.14762 17.8524 0 11.5 0ZM18.0714 9.52857L10.8429 16.7571C10.5143 17.0857 10.0762 17.1952 9.6381 17.1952C9.2 17.1952 8.76191 16.9762 8.43334 16.7571L4.70953 13.0333C4.38096 12.7048 4.27143 12.2667 4.27143 11.8286C4.27143 11.3905 4.49048 10.9524 4.70953 10.6238C5.0381 10.2952 5.47619 10.1857 5.91429 10.1857C6.35238 10.1857 6.79048 10.4048 7.11905 10.6238L9.6381 13.1429L15.7714 7.00952C16.1 6.68095 16.5381 6.57143 16.9762 6.57143C17.4143 6.57143 17.8524 6.79048 18.181 7.00952C18.7286 7.88571 18.7286 8.87143 18.0714 9.52857Z",
    fill: "#6FCF97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.95ff0028fd1d7e4547f8ceb494e0bdd7.svg";
export { ForwardRef as ReactComponent };